import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=c652723e&scoped=true"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=c652723e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c652723e",
  null
  
)

export default component.exports